import { type PureAbility, type InferSubjects } from '@casl/ability'

// アクション定義
export const Actions = {
  READ: 'Read',
  WRITE: 'Write',
  SHOW: 'Show'
} as const

export type Actions = (typeof Actions)[keyof typeof Actions]

// 画面ごとの定義
export const Subjects = {
  USER: 'User',
  USER_DETAIL: 'UserDetail',
  ATTENDANCE: 'Attendance',
  CHANGE_MY_PASSWORD: 'ChangeMyPassword',
  PROJECT: 'Project',
  PROJECT_USER: 'ProjectUser',
  PROJECT_CREATE: 'ProjectCreate',
  PROJECT_SALES_COST: 'ProjectSalesCost',
  USER_PROJECT: 'UserProject',
  ADD_PROJECT: 'AddProject',
  RESOURCE_PLAN: 'ResourcePlan',
  ASSIGN_BY_VOLUMED: 'AssignByVolumed',
  VOLUMED_ASSIGN: 'VolumedAssign',
  CLIENT: 'Client',
  DEPARTMENT: 'Department',
  PARTNER: 'Partner',
  JOB_SKILL: 'JobSkill',
  JOB_TITLE: 'JobTitle',
  HOLIDAY: 'Holiday',
  JOB: 'Job',
  CUSTOM_FIELD: 'CustomField',
  SETTING: 'Setting'
} as const

export type Subjects = (typeof Subjects)[keyof typeof Subjects]

// UI要素の定義
export const UISubjects = {
  // プロジェクト一覧画面
  PROJECT_LIST_DELETE_BUTTON: 'ProjectList.DeleteButton',
  PROJECT_LIST_COPY_BUTTON: 'ProjectList.CopyButton',
  // リソース計画画面
  RESOURCE_PLAN_ADD_USER_BUTTON: 'ResourcePlan.AddUserButton',
  RESOURCE_PLAN_PROJECT_PLAN_TABLE_EDIT_ASSIGN: 'ResourcePlan.ProjectPlanTable.EditAssign',
  RESOURCE_PLAN_PROJECT_PLAN_TABLE_ADD_BUTTONS: 'ResourcePlan.ProjectPlanTable.AddButtons',
  RESOURCE_PLAN_PROJECT_PLAN_TABLE_EDIT_ASSIGN_ICON: 'ResourcePlan.ProjectPlanTable.EditAssignIcon',
  // プロジェクト収支計画画面
  PROJECT_SALES_COST_EDIT_BUTTON: 'ProjectSalesAndCost.EditButton',
  PROJECT_SALES_COST_ADD_COST_BUTTON: 'ProjectSalesAndCost.AddCostButton',
  // 人材xプロジェクト画面
  USER_PROJECT_EDIT_ASSIGN: 'UserProject.EditAssign',
  USER_PROJECT_EDIT_ASSIGN_ICON: 'UserProject.EditAssignIcon',
  // プロジェクトx人材画面
  PROJECT_USER_ASSIGN_USER: 'ProjectUser.AssignUser',
  PROJECT_USER_EDIT_ASSIGN_ICON: 'ProjectUser.EditAssignIcon',
  // プロジェクト追加画面
  ADD_PROJECT_EDIT_ASSIGN: 'AddProject.EditAssign'
} as const

export type UISubject = (typeof UISubjects)[keyof typeof UISubjects]
export type AllSubjects = Subjects | UISubject

class ProjectUserCondition {
  userIds!: string[]
}

export type AllSubjectsWithCondition =
  | Subjects
  | UISubject
  | InferSubjects<typeof ProjectUserCondition>

// AppAbilityの型定義
export type AppAbility = PureAbility<[Actions, AllSubjectsWithCondition]>

// SubjectResolver関連の型と実装
export type ProjectId = string
export type Id = ProjectId
export type SubjectResolver = (params: Record<string, string | undefined>) => Promise<any>

export type RuleEntry =
  | {
      actions: Actions[]
      condition?: never
      fetch?: never
    }
  | {
      actions: Actions[]
      condition: (subject: any) => boolean
      fetch: SubjectResolver
    }

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export type RuleFactory<S extends AllSubjects> = (userId: string) => readonly RuleEntry[]

export type CompleteRuleSet = {
  readonly [K in AllSubjects]: RuleFactory<K>
}
